import React from "react";
import Tag from "../Tag";

// other classes: tags--small tags--small-spaced

const Tags = ({ data }) => {
    return (
        <div className="tags">
            {data.map(tag => <Tag key={tag.id} {...tag} />)}
        </div>
    )
}

export default Tags;